import { Col, InputField, Label, ReactSelectBox, Row, Tooltip } from 'client/CommonComponents'
import './VendorDetail.scss'
import { MaskedTextField } from "@fluentui/react";
import { CONSTANTS } from 'client/utils/constants';

const VendorDetail = (props?: any) => {
    const vendorDropdownList = props?.vendorDropdownList;
    const filterOptionVendor = props?.filterOptionVendor;
    const dealerSelectOnBlur = props?.dealerSelectOnBlur;
    const vendorSearchText = props?.vendorSearchText;
    const onChangeVendorName = props?.onChangeVendorName;
    const vendor = props?.vendor;
    const purchaseOrderStepperData = props?.purchaseOrderStepperData;
    const handleChange = props?.handleChange;
    const errors = props?.errors;
    const isNextClicked = props?.isNextClicked;

    return (
        <div className="vendordetail-container">
            <Row>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label">Vendor #</Label>
                    <Tooltip content={vendor?.label ?? ""}  data-attribute="VendorDetail_Default_Tooltip">
                    <ReactSelectBox
                        options={vendorDropdownList}
                        onChange={(item: any) => onChangeVendorName(item)}
                        value={vendor || ""}
                        name="vendorAbNumber"
                        isSearchable={true}
                        inputValue={vendorSearchText}
                        onInputChange={(value: any, action: any) => filterOptionVendor(value, action)}
                        className={(errors?.vendorAbNumber && isNextClicked ? "controlValidation me-2" : "me-2")}
                        onBlur={dealerSelectOnBlur}
                        isDisabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorAbNumber_SearchSelectBox" />
                    </Tooltip>
                    {errors?.vendorAbNumber && isNextClicked && (
                        <span className="validMessage">
                            {typeof errors?.vendorAbNumber === "string"
                                ? errors?.vendorAbNumber
                                : `Vendor Number is required`}
                        </span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_2">Vendor Name</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorName ?? ""}
                        onChange={handleChange}
                        name="vendorName"
                        placeholder="Vendor Name"
                        className={(errors?.vendorName && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorNameChanged) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorName_Input" />
                    {errors?.vendorName && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorNameChanged) && (
                        <span className="validMessage">
                            {
                                purchaseOrderStepperData?.vendorDetails?.vendorName?.length > 50 ?
                                    `Please enter Vendor Name less then 50 characters` :
                                    `Vendor Name is required`
                            }
                        </span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_3">Address Line 1</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorAdd1 ?? ""}
                        name="vendorAdd1"
                        onChange={handleChange}
                        className={(errors?.vendorAdd1 && (isNextClicked ||purchaseOrderStepperData?.vendorDetails?.isvendorAdd1Changed) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorAdd1_Input" />
                    {errors?.vendorAdd1 && (isNextClicked ||purchaseOrderStepperData?.vendorDetails?.isvendorAdd1Changed) && (
                        <span className="validMessage">
                            {purchaseOrderStepperData?.vendorDetails?.vendorAdd1?.length > 50 ?
                                "Please enter Address Line 1 less then 50 characters" :
                                "Address line 1 is required"}
                        </span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label data-attribute="VendorDetail_Default_Label_4">Address Line 2</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorAdd2 ?? ""}
                        name="vendorAdd2"
                        onChange={handleChange}
                        className={(errors?.vendorAdd2 && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorAdd2Changed) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorAdd2_Input" />
                    {errors?.vendorAdd2 && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorAdd2Changed) && (
                        <span className="validMessage">
                            Please enter Address Line 2 less then 50 characters
                        </span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_5">State/Province/Region</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorState ?? ""}
                        name="vendorState"
                        onChange={handleChange}
                        className={(errors?.vendorState && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorStateChanged) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorState_Input" />
                    {errors?.vendorState && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorStateChanged) && (
                        <span className="validMessage">{purchaseOrderStepperData?.vendorDetails?.vendorState?.length > 2 ?
                            "Please enter State less then 2 characters" :
                            "State is required"
                        } </span>
                    )}
                </Col>
                <Col xs={12} sm={12}  md={6}lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_6">City</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorCity ?? ""}
                        name="vendorCity"
                        onChange={handleChange}
                        className={(errors?.vendorCity && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorCityChanged) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorCity_Input" />
                    {errors?.vendorCity && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorCityChanged) && (
                        <span className="validMessage">{purchaseOrderStepperData?.vendorDetails?.vendorCity?.length > 50 ?
                            "Please enter City less then 50 characters" :
                            "City is required"}</span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_7">ZIP</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorZip ?? ""}
                        name="vendorZip"
                        onChange={handleChange}
                        className={(errors?.vendorZip && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorZipChanged) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorZip_Input" />
                    {errors?.vendorZip && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorZipChanged) && (
                        <span className="validMessage">{purchaseOrderStepperData?.vendorDetails?.vendorZip?.length > 12 ?
                            "Please enter Zip less then 12 characters" :
                            "ZIP is required"}</span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_8">Email Address</Label>
                    <InputField
                        value={purchaseOrderStepperData?.vendorDetails?.vendorContactEmail ?? ""}
                        onChange={handleChange}
                        name="vendorContactEmail"
                        placeholder="example@mail.com"
                        className={(errors?.vendorContactEmail && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorContactEmailChanged) ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="VendorDetail_vendorContactEmail_Input" />
                    {errors?.vendorContactEmail && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorContactEmailChanged) && (
                        <span className="validMessage">
                            {
                                purchaseOrderStepperData?.vendorDetails?.vendorContactEmail?.length > 50 ?
                                    "Please enter Email Address less than 50 characters" :
                                    "Please enter valid Email Address"
                            }
                        </span>
                    )}
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="VendorDetail_Default_Label_9">Phone</Label>
                    <MaskedTextField
                        name="vendorPhone"
                        value={purchaseOrderStepperData?.vendorDetails?.vendorPhone || ""}
                        onChange={(e: any, value: any)=>handleChange(e, value)}
                        placeholder="123-456-7890"
                        mask="999-999-9999"
                        className={(errors?.vendorPhone && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorPhoneChanged) ? "controlValidation form-input" : "form-input")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                    />
                    {errors?.vendorPhone && (isNextClicked || purchaseOrderStepperData?.vendorDetails?.isvendorPhoneChanged) && (
                        <span className="validMessage">
                            {(purchaseOrderStepperData?.vendorDetails?.vendorPhone?.length > 0 && purchaseOrderStepperData?.vendorDetails?.vendorPhone?.length < 12) ?
                                "Please enter valid phone number" :
                                "Phone is required"}
                        </span>
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default VendorDetail